<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard
          ref="formWizard"
          v-if="this.isCreate() || this.isUpdate()"
          @on-complete="storeUpdateFarm"
          title
          subtitle
          :back-button-text="$t('common_words.back')"
          :next-button-text="$t('common_words.next')"
          :finish-button-text="$t('common_words.save')"
          class="custom-padding-wz-header"
        >
          <tab-content
            :title="$t('common_words.general_information')"
            :before-change="() => validateStep('firstStep')"
          >
            <first-step
              ref="firstStep"
              @on-validated="onStepValidated"
              @showHideLoading="showHideLoading"
            ></first-step>
          </tab-content>
          <tab-content
            :title="$t('common_words.ubication')"
            :before-change="() => validateStep('secondStep')"
          >
            <second-step
              ref="secondStep"
              @on-validated="onStepValidated"
              @showHideLoading="showHideLoading"
            ></second-step>
          </tab-content>
          <tab-content
            :title="$t('common_words.crop')"
            :before-change="() => validateStep('thirdStep')"
          >
            <third-step
              ref="thirdStep"
              @setVarieties="setVarieties"
              @on-validated="onStepValidated"
              @showHideLoading="showHideLoading"
            ></third-step>
          </tab-content>
          <tab-content
            :title="$t('common_words.division')"
            :before-change="() => validateStep('fourthStep')"
          >
            <fourth-step
              ref="fourthStep"
              :crop_varieties="varieties"
              @on-validated="onStepValidated"
              @showHideLoading="showHideLoading"
            ></fourth-step>
          </tab-content>
          <tab-content :title="$t('common_words.confirm')">
            <p class="cm-mg-p-wzd text-center text-muted">
              5.1 {{ $t('common_words.verify_inputed_information') }}
            </p>
            <br />
            <div class="row d-flex justify-content-center">
              <div class="col-9">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.farm') }}:</strong>
                        </h6>
                        {{ farmForm.name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.code') }}:</strong>
                        </h6>
                        {{ farmForm.code }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.farm_size_ha') }}</strong>
                        </h6>
                        {{ farmForm.area }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.crop') }}:</strong>
                        </h6>
                        {{ farmForm.nameCrop }} - {{ farmForm.nameCropType }}
                      </td>
                    </tr>
                    <tr
                      class="shadow-sm"
                      v-if="farmForm.crop_id == 1 || farmForm.crop_id == 2"
                    >
                      <td scope="col">
                        <h6>
                          <strong
                            >{{
                              $t('production.weight_tara_percentage')
                            }}:</strong
                          >
                        </h6>
                        {{ farmForm.tara_weight }} %
                      </td>
                    </tr>
                    <tr
                      class="shadow-sm"
                      v-if="farmForm.crop_id == 1 || farmForm.crop_id == 2"
                    >
                      <td scope="col">
                        <h6>
                          <strong
                            >{{ $t('production.box_unit_weight') }}:</strong
                          >
                        </h6>
                        {{ farmForm.unit_box_weight }}
                      </td>
                    </tr>
                    <tr
                      class="shadow-sm"
                      v-if="farmForm.crop_id == 1 || farmForm.crop_id == 2"
                    >
                      <td scope="col">
                        <h6>
                          <strong
                            >{{
                              $t('production.cluster_fruit_unit_weight')
                            }}:</strong
                          >
                        </h6>
                        {{ farmForm.unit_tara_weight }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{ $t('common_words.blocks_number_2') }}:</strong
                          >
                        </h6>
                        <span
                          v-for="(name, index) in farmForm.name_blocks"
                          :key="index"
                        >
                          <el-tag type="info">{{ name }}</el-tag>
                        </span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{
                              $t('common_words.allotment_number_2')
                            }}:</strong
                          >
                        </h6>
                        <span
                          v-for="(_, index) in farmForm.lots_number"
                          :key="index"
                        >
                          <el-tag type="info" style="height: auto; width: 240px"
                            >{{ $t('common_words.name') }}:
                            {{ farmForm.name_lots[index] }}<br />
                            {{ $t('common_words.area') }}:
                            {{ farmForm.area_lots[index] }}<br />
                            {{ $t('common_words.variety') }}:
                            {{ farmForm.name_varieties[index] }} <br />
                            {{ $t('common_words.soil_type') }}:
                            <span style="text-transform: capitalize">{{
                              farmForm.name_soils[index]
                                ? farmForm.name_soils[index]
                                : 'Ninguno'
                            }}</span>
                            <br />{{ $t('common_words.population') }}:
                            {{
                              farmForm.population[index]
                                ? farmForm.population[index]
                                : 'Ninguna'
                            }}</el-tag
                          >
                        </span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{
                              $t('common_words.blocks_allotment_relation_2')
                            }}:</strong
                          >
                        </h6>
                        <span
                          v-for="(names, index) in farmForm.blocks_rel"
                          :key="index"
                        >
                          <el-tag type="info"
                            ><span
                              >{{ names }} :
                              {{ farmForm.lots_rel[index].join(', ') }}</span
                            ></el-tag
                          >
                        </span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong>{{ $t('production.scales') }}:</strong>
                        </h6>
                        <span
                          v-for="(device, index) in farmForm.nameDevices"
                          :key="index"
                        >
                          <el-tag type="info">{{ device }}</el-tag>
                          <br v-if="index % 5 == 0 && index != 0" />
                        </span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{
                              $t('common_words.associated_companies')
                            }}:</strong
                          >
                        </h6>
                        <span
                          v-for="(business, index) in farmForm.names_business"
                          :key="index"
                        >
                          <el-tag type="info">{{ business }}</el-tag>
                          <br v-if="index % 5 == 0 && index != 0" />
                        </span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{
                              $t('common_words.notification_email')
                            }}:</strong
                          >
                        </h6>
                        {{ farmForm.email_notification }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.address') }}:</strong>
                        </h6>
                        {{ farmForm.zip_code ? `${farmForm.zip_code} - ` : '' }}
                        - {{ farmForm.city }} , {{ farmForm.state }} -
                        {{ farmForm.country }};
                        {{ farmForm.address }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{ $t('common_words.geo_position') }}:</strong
                          >
                        </h6>
                        Lat: {{ farmForm.latitude }} - Lon:
                        {{ farmForm.longitude }} - Alt: {{ farmForm.altitude }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-9">
                <div
                  ref="map"
                  class="map"
                  v-if="renderComponent"
                  style="height: 500px"
                ></div>
              </div>
              <div class="col-9">
                <br />
                <p>
                  {{ $t('common_words.files_loaded') }}:
                  <span
                    v-for="(files, index) in farmForm.names_files"
                    :key="index"
                  >
                    <el-tag type="info">{{ files }}</el-tag>
                  </span>
                </p>
              </div>
            </div>
          </tab-content>
        </form-wizard>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_operations') }}:
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import FirstStep from './steps/FirstStep.vue';
import SecondStep from './steps/SecondStep.vue';
import ThirdStep from './steps/ThirdStep.vue';
import FourthStep from './steps/FourthStep.vue';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import { Axios } from 'src/class/Axios.js';
import mixinMasters from 'src/util/mixinMasters';
import { showContinue } from 'src/util/Util.js';
import MixinMenu from 'src/util/mixinMenu';

export default {
  components: {
    FirstStep,
    SecondStep,
    ThirdStep,
    FourthStep,
  },
  data() {
    return {
      center: {
        lat: 10.8906,
        lng: -74.18756,
      },
      varieties: [],
      title: '',
      farmForm: {
        calendar_id: 1,
        name_blocks: [],
        lots_rel: [],
        nameDevices: [],
        names_business: [],
        names_files: [],
        other_values: [],
      },
      map: null,
      renderComponent: true,
    };
  },

  mixins: [MixinPermissions, MixinArcgisMap, mixinMasters, MixinMenu],

  methods: {
    setVarieties(varieties) {
      this.varieties = varieties;
    },

    cleanAllSteps() {
      this.$refs.firstStep.model = {
        id: null,
        name: null,
        code: null,
        area: null,
        email_notification: null,
        email_notification_two: null,
        businesses_id: [],
      };
      this.$refs.secondStep.model = {
        zone: null,
        subzone: null,
        id: null,
        address: null,
        latitude: null,
        longitude: null,
        altitude: null,
        country: null,
        city: null,
        state: null,
        other_values: [],
        listFiles: {
          Perimetro: [],
          Bloques: [],
          Lotes: [],
          Drenaje: [],
          Suelo: [],
          CableVia: [],
          Reservorio: [],
          Construcciones: [],
        },
      };
      this.$refs.thirdStep.model = {
        crop_id: null,
        crop_type_id: null,
        devices: [],
        tara_weight: 0,
        unit_tara_weight: 'kg',
        unit_box_weight: 'kg',
      };
      this.$refs.fourthStep.model = {
        blocks_number: null,
        lots_number: null,
        id_blocks: [],
        name_blocks: [],
        id_lots: [],
        name_lots: [],
        area_lots: [],
        crop_varieties_id: [],
        blocks_rel: [],
        lots_rel: [],
      };
      this.farmForm = {
        calendar_id: 1,
        name_blocks: [],
        lots_rel: [],
        nameDevices: [],
        names_business: [],
        names_files: [],
        other_values: [],
      };
    },

    validateStep(ref) {
      return this.$refs[ref].validate();
    },

    onStepValidated(_, model) {
      this.farmForm = { ...this.farmForm, ...model };
      this.center.lat = this.farmForm.latitude
        ? parseFloat(this.farmForm.latitude)
        : this.center.lat;
      this.center.lng = this.farmForm.longitude
        ? parseFloat(this.farmForm.longitude)
        : this.center.lng;

      this.fillFiles();

      this.loadMap();
    },

    storeUpdateFarm() {
      this.showHideLoading(true);
      this.farmForm.route = 'farms/farms';
      this.fillFiles();

      if (sessionStorage.getItem('editForm')) {
        if (this.isUpdate()) {
          this.farmForm.id = JSON.parse(sessionStorage.getItem('editForm')).id;
          Axios.updateMaster(this.farmForm)
            .then((response) => {
              if (this.farmForm.names_files.length > 0)
                axios.post('/auth/farms/farms/movekml', {
                  name: this.farmForm.names_files,
                  farm: this.farmForm.id,
                  user: this.$store.state.auth.user.id,
                });

              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/farms/farms',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.farmForm)
            .then((response) => {
              if (this.farmForm.names_files.length > 0)
                axios.post('/auth/farms/farms/movekml', {
                  name: this.farmForm.names_files,
                  farm: response.data.data.id,
                  user: this.$store.state.auth.user.id,
                });

              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/farms/farms',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },

    fillFiles() {
      this.farmForm.names_files = [];
      let lfTmp = JSON.parse(localStorage.getItem('listFiles'));

      for (const key in lfTmp) {
        if (Object.hasOwnProperty.call(lfTmp, key)) {
          const element = lfTmp[key];
          if (element && element[0] && element.length > 0) {
            this.farmForm.names_files.push(key);
          }
        }
      }
    },

    loadMap() {
      this.renderComponent = false;
      let namesFiles = [];
      let lfTmp = JSON.parse(localStorage.getItem('listFiles'));

      for (const key in lfTmp) {
        if (Object.hasOwnProperty.call(lfTmp, key)) {
          const element = lfTmp[key];
          if (sessionStorage.getItem('editForm')) {
            if (this.farmForm.other_values.includes(key)) {
              if (element && element[0]) {
                if (!element[0].editFile || element.length == 0) {
                  namesFiles.push(
                    this.farmForm.id + '/' + key + '|' + this.farmForm.name
                  );
                } else {
                  if (element.length > 0) {
                    namesFiles.push(
                      'tmp/' +
                        this.$store.state.auth.user.id +
                        '/' +
                        key +
                        '|' +
                        this.farmForm.name
                    );
                  }
                }
              } else {
                namesFiles.push(
                  'tmp/' +
                    this.$store.state.auth.user.id +
                    '/' +
                    key +
                    '|' +
                    this.farmForm.name
                );
              }
            }
          } else {
            if (element && element[0] && element.length > 0) {
              namesFiles.push(
                'tmp/' +
                  this.$store.state.auth.user.id +
                  '/' +
                  key +
                  '|' +
                  this.farmForm.name
              );
            }
          }
        }
      }

      this.$nextTick(() => {
        this.renderComponent = true;
        this.loadMapMultipleC(namesFiles, false);
      });
    },
  },

  mounted() {
    this.selectedItemOnMenu('farms/crops');
  },

  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    this.deselectedItemOnMenu('farms/crops');
  },
};
</script>

<style>
.vue-form-wizard .wizard-icon-circle .wizard-icon-container {
  border-radius: 100% !important;
}
</style>
